export default "dist/images/block-call-to-action-split-centered.c78f0d4.png";